import enUS from './en-US';

export default {
  ...enUS,
  'navBar.lang': 'Idiomas',
  'layout.user.link.help': 'Ayuda',
  'layout.user.link.privacy': 'Privacidad',
  'layout.user.link.terms': 'Términos',
  'component.logout.label': 'Cerrar sesión',
  'component.globalHeader.search': 'Buscar',
  'component.globalHeader.help': 'Ayuda',
  'component.globalHeader.notification': 'Notificaciones',
  'component.globalHeader.message': 'Mensajes',
  'component.globalHeader.event': 'Eventos',
  'component.noticeIcon.clear': 'Borrar',
  'component.noticeIcon.cleared': 'Borrado',
  'component.noticeIcon.empty': 'Sin notificaciones',
  'component.noticeIcon.view-more': 'Ver más',
  'component.refresh': 'Actualizar',
  'component.copyAddress': 'Copiar dirección',
  'component.copySuccess': 'Dirección copiada',
  'component.endOfList': 'Fin de la lista',
  'menu.home': 'Inicio',
  'menu.login': 'Iniciar sesión',
  'menu.register': 'Registrarse',
  'menu.org': 'Panel',
  'menu.org.home': 'Panel',
  'menu.org.analysis': 'Análisis',
  'menu.management': 'Administración',
  'menu.management.site-list': 'Sitios',
  'menu.management.players': 'Jugadores',
  'menu.management.players.detail': 'Detalles del jugador',
  'menu.management.game': 'Juegos',
  'menu.management.game.category': 'Categorías de juegos',
  'menu.management.contents': 'Contenido',
  'menu.settings.finance': 'Finanzas',
  'menu.account': 'Cuenta',
  'menu.settings': 'Cuenta y configuración',
  'menu.account.center': 'Centro de cuentas',
  'menu.account.settings': 'Configuración de la cuenta',
  'menu.account.logout': 'Cerrar sesión',
  'pages.login.accountLogin.tab': 'Área de miembros',
  'pages.login.failure': 'No se pudo iniciar sesión. ¡Inténtalo de nuevo!',
  'pages.login.username.placeholder': 'ID de miembro / usuario',
  'pages.login.username.required': '¡Introduce tu nombre de usuario!',
  'pages.login.password.placeholder': 'Contraseña',
  'pages.login.password.required': '¡Introduce tu contraseña!',
  'pages.login.rememberMe': 'Recordarme',
  'pages.login.forgotPassword': '¿Olvidaste la contraseña?',
  'pages.login.submit': 'Iniciar sesión',
  'pages.login.registerAccount': 'Crear cuenta',
  'pages.login.pleaseVerifyCaptcha': 'Confirma que no eres un robot.',
  'app.pwa.offline': 'Ahora estás sin conexión',
  'app.pwa.serviceworker.updated': 'Hay contenido nuevo disponible',
  'app.pwa.serviceworker.updated.ok': 'Actualizar',
};
